import * as Yup from 'yup';

export default function validateSubscriptionEmail() {
  return Yup.string().required('Email address is required').email('Please enter a valid email');
}
